@import '../../../node_modules/@ionic/core/css/core.css';

.amwal-checkout-button {
  display: flex;
  font-family: 'Cairo', sans-serif;
  font-weight: bolder;
}

.hidden {
  display: none;
}


body.amwal-overlay-active {
  overflow: hidden;
}

.amwal-overlay {
  position: fixed;
  z-index: 999999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .75);
  display: flex;
  align-items: center;
  justify-content: center;
}

.amwal-overlay-container {
  text-align: center;
  font: 400 16px Arial, sans-serif;
  color: #fafafa;
}

.amwal-overlay-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 24px;
  cursor: pointer;
  transition: transform .5s ease-in-out;
}

.amwal-overlay-button,
.amwal-overlay-button:link,
.amwal-overlay-button:target,
.amwal-overlay-button:active,
.amwal-overlay-button:hover,
.amwal-overlay-button:visited,
.amwal-overlay-button:focus {
  display: inline;
  background-color: transparent;
  color: white;
  text-decoration: underline;
  outline: none;
  cursor: pointer;
}

ion-modal {
  --width: 35vw;
  --height: 85vh;
  --border-radius: 10px;
  position: fixed;
}

@media only screen and (max-width: 1000px) and (min-width: 700px) {
  ion-modal {
    --width: 100vw;
    --height: 100vh;
  }
}

@media only screen and (max-width: 690px) {
  ion-modal {
    --width: 100vw;
    --height: 100vh;
    --border-radius: 0px;
  }
  .amwal-checkout-button {
    --border-radius: 4px;
  }

  .ribbon {
    width: 34px !important;
    left: 0;
  }

  .ribbon ~ .button-text {
    font-size: 14px;
  }

  .ribbon:after {
    border-left: 17px solid #F8463F !important;
    border-right: 17px solid #F8463F !important;
  }
}

@media only screen and (max-height: 690px) {
  ion-modal {
    --width: 100%;
    --height: 100%;
    --border-radius: 0px;
  }
}

:root {
  /* --ion-color-dark: #2F7D31 !important; */
  --ion-color-dark: #000000 !important;
}

.amwal-checkout-button {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
}

amwal-checkout-button button {
  height: unset !important;
}

.vl {
  border-left: 2px solid white;
  height: 15px;
  margin: 10px;
}

.amwal-checkout-button-height {
  height: 35px !important;
}


.payment-brand-class {
  /* justify-content: center !important;
  align-items: center; */
  max-width: 360px;
}

.payment-brand-class img {
  /* padding: 5px; */
  height: 13px;
  width: 30px;
  /* align-self: center; */
  /* border: 1px solid lightgray; */
  /* border-radius: 5px; */
  margin: 2px;
  object-fit: contain;
  box-sizing: content-box;
  padding-top: 1px;
}

.masterLogo {
  border: none !important;
}

.logo-white {
  background-color: white;
}

.mada-logo {
  padding: 0px !important;
  height: 30px !important;
  width: 50px !important;
}

.ribbon {
  width: 34px;
  padding: 10px 0;
  position: absolute;
  top: -14px;
  left: -15px;
  text-align: center;
  font-size: 12px;
  border-top-left-radius: 3px;
  background: #F8463F;
}

.ribbon:before, .ribbon:after {
  content: "";
  position: absolute;
}
.ribbon:after {
  height: 0;
  width: 0;
  bottom: -7px;
  left: 0;
  border-left: 17px solid #F8463F;
  border-right: 17px solid #F8463F;
  border-bottom: 7px solid transparent;
}
.button-text{
  margin: 10px;
}